/* Demaf Wholesale — 캐러셀(좌우 스크롤)
   - 데스크탑: 마우스 드래그 + 관성(momentum) 스크롤 (자연스러운 감속)
   - 모바일: 네이티브 터치 관성 그대로
   - 제품 캐러셀 화살표(prev/next), 마켓 dot 동기화 */
(function () {
  'use strict';

  var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function enableDragScroll(el) {
    if (!el || el.dataset.dragInit) return;
    el.dataset.dragInit = '1';
    if (!finePointer) return; // 모바일은 네이티브 관성 사용

    var down = false, moved = false;
    var startX = 0, startLeft = 0;
    var lastX = 0, lastT = 0, vel = 0, raf = null;

    function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function stopRaf() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false;
      startX = e.pageX; startLeft = el.scrollLeft;
      lastX = e.pageX; lastT = now(); vel = 0;
      stopRaf();
      el.classList.add('is-grabbing');
      el.style.scrollSnapType = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startLeft - dx;
      var t = now(), dt = t - lastT;
      if (dt > 0) vel = (e.pageX - lastX) / dt; // px/ms
      lastX = e.pageX; lastT = t;
    });

    document.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-grabbing');
      var v = vel * 16; // 초기 프레임 속도(px/frame)
      (function momentum() {
        if (Math.abs(v) < 0.4) { el.style.scrollSnapType = ''; raf = null; return; }
        el.scrollLeft -= v;
        v *= 0.93; // 감속
        raf = requestAnimationFrame(momentum);
      })();
    });

    // 드래그 직후 링크 클릭 방지
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    // 드래그 중 이미지 고스트/텍스트 선택 방지
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initProductNav(sec) {
    var track = sec.querySelector('.product-carousel');
    var nav = sec.querySelector('.essentials__nav');
    if (!track || !nav) return;
    var btns = nav.querySelectorAll('button');
    var prev = btns[0], next = btns[1];
    function step() {
      var card = track.querySelector('.card');
      var gap = 16;
      return card ? (card.offsetWidth + gap) * (window.innerWidth >= 1024 ? 2 : 1) : 260;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initMarketDots(strip) {
    var row = strip.querySelector('.markets__row');
    var dots = strip.querySelectorAll('.market-dot');
    if (!row || dots.length < 2) return;
    var n = dots.length - 1;
    function setActive(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    row.addEventListener('scroll', function () {
      var max = row.scrollWidth - row.clientWidth;
      var ratio = max > 0 ? row.scrollLeft / max : 0;
      setActive(Math.round(ratio * n));
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var max = row.scrollWidth - row.clientWidth;
        row.scrollTo({ left: max * (i / n), behavior: 'smooth' });
      });
    });
  }

  // 릴 영상: 화면에 보일 때만 자동 재생(muted), 벗어나면 정지. 탭하면 재생/정지 토글.
  function initReels() {
    var vids = document.querySelectorAll('.reels video');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.5) {
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }
    vids.forEach(function (v) {
      v.addEventListener('click', function () {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    });
  }

  function init() {
    document.querySelectorAll('.hscroll, .markets__row, .product-carousel').forEach(enableDragScroll);
    document.querySelectorAll('.essentials').forEach(initProductNav);
    document.querySelectorAll('.markets__strip').forEach(initMarketDots);
    initReels();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
